import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewRequest = (id) =>
  useQuery({
    queryKey: riskReviewKeys.request(id),
    queryFn: () => riskReviewService.getRequest(id),
    enabled: Boolean(id),
    staleTime: 5000,
  });
